module.exports = __webpack_public_path__ + "assets/select.be2885c0.svg";